import React from 'react';

import DebugModal from '~/components/DebugModal/DebugModal';

function VersionedInfoDebugButton({
  fieldName,
  offerId,
  data,
}: {
  fieldName: 'hotelInfo' | 'flightInfo';
  offerId?: string | null;
  data: unknown;
}) {
  const label = `${fieldName} V1 - ${offerId ?? 'unknown'}`;

  return (
    <DebugModal type="generic" title={label} data={data} buttonProps={{ variant: 'text', size: 'small' }}>
      {label}
    </DebugModal>
  );
}

export default VersionedInfoDebugButton;
